import { render, staticRenderFns } from "./PackagingTracking_BioBridge.vue?vue&type=template&id=6219b95d"
import script from "./PackagingTracking_BioBridge.vue?vue&type=script&lang=js"
export * from "./PackagingTracking_BioBridge.vue?vue&type=script&lang=js"
import style0 from "./PackagingTracking_BioBridge.vue?vue&type=style&index=0&id=6219b95d&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports